import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import { darkGreenColor, grayColor, isTaskDialog, redColor, whiteColor } from "../../constants/constants";
import { closeRemoveDialog } from "../../core/state/dialogs/removeTaskTagDialogSlice";
import { useAppDispatch, useAppSelector } from "../../core/state/hooks";
import {
    fetchDeleteTag,
    fetchDeleteTask,
    fetchTags,
    fetchTasks
} from "../../core/state/tasksTags/tasksTagsSlice";

export default function RemoveTaskTagDialog() {
    const dispatch = useAppDispatch();
    const { isOpen: dialogIsOpen, TaskId, TagId, dialogType } = useAppSelector((state) => state.removeTaskTagDialog);

    const confirmationMessage = dialogType === isTaskDialog 
        ? '¿Desea eliminar la tarea?' 
        : '¿Desea eliminar el tag?';

    const handleCancel = () => {
        dispatch(closeRemoveDialog());
    };

    const handleDelete = () => {
        dispatch(closeRemoveDialog());
        
        if (dialogType === isTaskDialog) {
            dispatch(fetchDeleteTask(TaskId)).then(() => dispatch(fetchTasks()));
        } else {
            dispatch(fetchDeleteTag(TagId)).then(() => dispatch(fetchTags()));
        }
    };

    return (
        <Dialog 
            open={dialogIsOpen} 
            onClose={handleCancel}
            maxWidth="xs"
            slotProps={{
                backdrop: {
                    sx: { backgroundColor: 'transparent' }
                }
            }}
            PaperProps={{
                sx: {
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
                    borderRadius: 2
                }
            }}
        >
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
                <Typography variant='h6' sx={{ mb: 3 }}>{confirmationMessage}</Typography>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button 
                        sx={{
                            px: 3,
                            py: 1,
                            backgroundColor: grayColor, 
                            color: whiteColor,
                            '&:hover': { backgroundColor: darkGreenColor }
                        }}
                        onClick={handleCancel}
                    >
                        Cancelar
                    </Button>
                    <Button 
                        sx={{
                            px: 3,
                            py: 1,
                            backgroundColor: redColor, 
                            color: whiteColor,
                            '&:hover': { backgroundColor: darkGreenColor }
                        }}
                        onClick={handleDelete}
                    >
                        Eliminar
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}